import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * DemoDialog — legacy modal. Now acts as a redirect shim so every existing
 * `setDemoOpen(true)` call site across the site funnels users to the full
 * `/book-demo` page (single source of truth for demo requests).
 */
export default function DemoDialog({ open, onClose }) {
  const navigate = useNavigate();
  useEffect(() => {
    if (open) {
      if (onClose) onClose();
      navigate("/book-demo");
    }
  }, [open, onClose, navigate]);
  return null;
}
